import { Component, OnInit, OnDestroy } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-file-upload-aws',
    templateUrl: './file-upload-aws.component.html',
    styleUrls: ['./file-upload-aws.component.scss']
})
export class FileUploadAWSComponent implements OnInit, OnDestroy {
    fileName = '';
    processPercent = 0;
    color: ThemePalette = 'primary';
    mode: ProgressBarMode = 'determinate';
    bufferValue = 75;

    private _unsubscribeAll: Subject<any>;

    constructor() {
        this._unsubscribeAll = new Subject<any>();
    }

    ngOnInit(): void {}

    onUpload(id: string): void {
        const input = document.getElementById(id);
        input.click();
    }

    onSelectFile(event: any): void {
        const files = event.target.files;
        this.fileName = files[0] ? files[0].name : null;
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
